export default "__VITE_ASSET__CdL$rNtI__"